"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTradingTokenManager = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const interface_1 = require("../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const errors_1 = require("../interface/errors");
class ClientTradingTokenManager extends interface_1.BaseTokenManager {
    requestTradingBotTokenImpl(key) {
        return (0, rxjs_1.of)(0).pipe((0, operators_1.mergeMap)(() => {
            if (key) {
                return (0, rxjs_1.zip)((0, trade_utils_lib_1.getTradeDependencyInstance)().getAccessToken(this.consumeForceUpdateAccessToken()), (0, trade_utils_lib_1.getTradeDependencyInstance)().getRSAPublicKey()).pipe((0, operators_1.map)((result) => {
                    return {
                        awsToken: result[0],
                        rsaPublicKey: result[1],
                        aesKey: (0, trade_utils_lib_1.random32String)(),
                    };
                }));
            }
            else {
                return (0, rxjs_1.zip)((0, trade_utils_lib_1.getTradeDependencyInstance)().getAccessToken(this.consumeForceUpdateAccessToken()), (0, trade_utils_lib_1.getTradeDependencyInstance)().getRSAPublicKey()).pipe((0, operators_1.map)((result) => {
                    return {
                        awsToken: result[0],
                        rsaPublicKey: result[1],
                        aesKey: (0, trade_utils_lib_1.random32String)(),
                    };
                }));
            }
        }), (0, operators_1.mergeMap)((requestParam) => {
            if (!requestParam.awsToken) {
                ///> 无效的参数，不用请求了
                throw errors_1.ErrorNotGetAccessToken;
            }
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().manageApiHost}/trade_token/`;
            let body = {
                secret: (0, trade_utils_lib_1.encryptAESKey)(requestParam.rsaPublicKey, requestParam.aesKey),
            };
            return trade_utils_lib_1.NetworkUtils.postV2({ url, data: body, authorize: true }).pipe((0, operators_1.map)((data) => {
                var _a, _b, _c;
                const expire_at_arr = [(_a = data.spot) === null || _a === void 0 ? void 0 : _a.expire_at, (_b = data.swap) === null || _b === void 0 ? void 0 : _b.expire_at, (_c = data.trader) === null || _c === void 0 ? void 0 : _c.expire_at].filter((e) => Number(e) > 0);
                const expire_at = Math.min(...expire_at_arr);
                const parseInfo = {
                    id: key,
                    apiSecret: (0, trade_utils_lib_1.decryptApiSecret)(data.spot.api_secret, requestParam.aesKey),
                    tradingToken: data.spot.token,
                    awsToken: requestParam.awsToken,
                    swapApiSecret: data.swap && data.swap.api_secret ? (0, trade_utils_lib_1.decryptApiSecret)(data.swap.api_secret, requestParam.aesKey) : "",
                    swapToken: data.swap ? data.swap.token : "",
                    traderToken: data.trader ? data.trader.token : "",
                    traderApiSecret: data.trader ? (0, trade_utils_lib_1.decryptApiSecret)(data.trader.api_secret, requestParam.aesKey) : "",
                    tokenExpire: expire_at,
                };
                return parseInfo;
            }), (0, operators_1.catchError)((error) => {
                if ((error === null || error === void 0 ? void 0 : error.code) === 40101612) {
                    //{
                    // 	"code": 40101612,
                    // 	"message": "Invalid token: this token has been revoked",
                    // 	"data": null
                    // }
                    this.updateAccessToken();
                }
                const empty = {
                    id: "default",
                    apiSecret: "",
                    tradingToken: "",
                    awsToken: requestParam["awsToken"],
                    swapApiSecret: "",
                    swapToken: "",
                    tokenExpire: 0,
                };
                return (0, rxjs_1.of)(empty);
            }), (0, operators_1.tap)((result) => {
                if (result.tradingToken) {
                    this.updateTokenCacheResult(key, result);
                }
            }));
        }));
    }
}
exports.ClientTradingTokenManager = ClientTradingTokenManager;
